export default __webpack_public_path__ + "static/media/housing.fcaba582.png";